import { Button, Space, message } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { CopyOutlined } from "@ant-design/icons";

export const BotonesCopiarClipboard = () => {
  const { asistencia } = useSelector((state) => state.detalleReducer);

  const extraerValor = (campo) => {
    if (!campo) return "";
    const partes = campo.split(":");
    return partes.length > 1 ? partes[1].trim() : campo.trim();
  };

  const generarPlantillaCotizar = () => {
    const servicio = asistencia.servicio?.nombre || "N/A";
    const origen = asistencia.direccionOrigen
      ? `${asistencia.direccionOrigen} (${asistencia.municipioOrigen || "N/A"})`
      : "N/A";
    const destino = asistencia.direccionDestino
      ? `${asistencia.direccionDestino} (${asistencia.municipioDestino || "N/A"})`
      : "N/A";

    let camposTexto = "";
    for (let i = 1; i <= 12; i++) {
      const campo = asistencia[`campo${i}`];
      if (campo && campo.trim() && !campo.toLowerCase().includes("placa")) {
        camposTexto += `${campo}\n`;
      }
    }

    return `Hola me puedes apoyar por favor a cotizar un servicio de ${servicio}

Origen: ${origen}
Destino: ${destino}
${camposTexto}
Favor de detallar el desglose de costos (En caso de ser carretero, casetas, contar con maniobra acondicionamiento o carga).`;
  };

  const generarPlantillaAsignar = () => {
    const nombreCompleto = [
      asistencia.nombreLlamada,
      asistencia.apellidoPaternoLlamada,
      asistencia.apellidoMaternoLlamada
    ].filter(Boolean).join(" ") || "N/A";

    const expediente = asistencia.asegurado?.validador1 || "N/A";

    const marca = extraerValor(asistencia.campo6);
    const tipo = extraerValor(asistencia.campo7);
    const modelo = extraerValor(asistencia.campo9);
    const vehiculo = [marca, tipo, modelo].filter(Boolean).join(" ") || "N/A";

    const proveedor = asistencia.proveedorSucursal?.proveedor?.nombreComercial || "N/A";

    const horaAsignacion = asistencia.fechaAsignacion
      ? new Date(asistencia.fechaAsignacion).toLocaleString('es-MX', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
      : "N/A";

    return `Me puedes apoyar por favor con el servicio de: Grúa y asistencias Viales (Paso de corriente, cambio de llanta y Gasolina)

Nombre de Asegurado: ${nombreCompleto}
Expedientes: ${expediente}
Vehículo: ${vehiculo}
Asigna: ${proveedor}
Hora de Asignación: ${horaAsignacion}

Favor de enviar foto de placa al contacto y si hay daños persistentes, también adjuntar fotos.`;
  };

  const generarPlantillaSeguimiento = () => {
    const expediente = asistencia.asegurado?.validador1 || "N/A";

    return `Buen día.

Me apoyan con seguimiento del servicio Expediente: ${expediente}

confirmando los siguientes datos:

Operador:
Tipo de unidad:
Tiempo de contacto:`;
  };

  const copiarAlClipboard = (tipo) => {
    let plantilla = "";

    switch(tipo) {
      case "cotizar":
        plantilla = generarPlantillaCotizar();
        break;
      case "asignar":
        plantilla = generarPlantillaAsignar();
        break;
      case "seguimiento":
        plantilla = generarPlantillaSeguimiento();
        break;
      default:
        plantilla = "";
    }

    navigator.clipboard.writeText(plantilla).then(() => {
      message.success(`Plantilla de ${tipo} copiada al clipboard`);
    }).catch(() => {
      message.error("Error al copiar al clipboard");
    });
  };

  if (asistencia.estatusID !== 2) return null;

  return (
    <Space>
      <Button
        size="small"
        icon={<CopyOutlined />}
        onClick={() => copiarAlClipboard("cotizar")}
      >
        Cotizar
      </Button>
      {/* <Button
        size="small"
        icon={<CopyOutlined />}
        onClick={() => copiarAlClipboard("asignar")}
      >
        Asignar
      </Button>
      <Button
        size="small"
        icon={<CopyOutlined />}
        onClick={() => copiarAlClipboard("seguimiento")}
      >
        Seguimiento
      </Button> */}
    </Space>
  );
};